import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import { OktaRouteEnum } from '~/router/@types';
import LoadingCircularProgress from '~/components/LoadingCircularProgress';

const OktaAuth = lazy(() => import('~/components/User/OktaAuth'));
const OktaAuthCallback = lazy(() => import('~/components/User/OktaAuthCallback'));
const OktaAuthSamlCallback = lazy(() => import('~/components/User/OktaAuthSamlCallback'));

export const OKTA_ROUTES: RouteObject[] = [
  {
    path: OktaRouteEnum.Auth,
    element: (
      <Suspense fallback={<LoadingCircularProgress open />}>
        <OktaAuth />
      </Suspense>
    ),
  },
  {
    path: OktaRouteEnum.Callback,
    element: (
      <Suspense fallback={<LoadingCircularProgress open />}>
        <OktaAuthCallback />
      </Suspense>
    ),
  },
  {
    path: OktaRouteEnum.SamlCallback,
    element: (
      <Suspense fallback={<LoadingCircularProgress open />}>
        <OktaAuthSamlCallback />
      </Suspense>
    ),
  },
];
